import { ITitleAndIntro, TitleAndIntroProps } from './types';

export const mapTitleAndIntro = ({
  prismicContent,
}: {
  prismicContent: TitleAndIntroProps['slice'];
}): ITitleAndIntro => {
  const {
    primary: {
      title,
      title_style: titleStyle,
      introduction,
      content_alignment: contentAlignment,
    },
  } = prismicContent;

  return {
    title,
    titleStyle,
    introduction,
    contentAlignment,
  };
};
